import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BuildInformationComponent } from '../../admin/build-information/build-information.component';

@Component({
  selector: 'app-tech-notes-modal',
  templateUrl: './tech-notes-modal.component.html',
  styleUrls: ['./tech-notes-modal.component.scss'],
  imports: [MatButtonModule, BuildInformationComponent],
})
export class TechNotesModalComponent {
  private dialogRef =
    inject<MatDialogRef<TechNotesModalComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  close() {
    this.dialogRef.close({ data: 'cancel' });
  }
}
